import { AuthenticatedUser, ISchedule, ISlot } from '@gettactic/api';
import { isPast } from 'date-fns';
import { canScheduleOthers } from '../permissions';

export function findCheckinTargetSlot(
  schedule: ISchedule,
  targetUserId: string
) {
  const slotsForUser = schedule.slots.filter((x) => x.user.id === targetUserId);
  return slotsForUser.find((x) => x.resource.id === schedule.resource.id);
}
export function getCurrentUserCanEdit(
  schedule: ISchedule,
  authenticatedUser: AuthenticatedUser,
  prioritySlot?: ISlot
): boolean {
  // Check if schedule is in the past
  const endDate = new Date(schedule.end.replace('Z', ''));
  const scheduleInThePast = isPast(endDate);

  // Find the target slot for the current user
  const targetSlot = findCheckinTargetSlot(
    schedule,
    authenticatedUser.user?.id ?? ''
  );

  // Use provided prioritySlot or get the first slot from schedule
  const slotToCheck = prioritySlot || schedule.slots[0];

  // If we couldn't find a target slot, user can't edit
  if (!targetSlot) {
    return false;
  }

  // Check permissions
  const canEdit = !!targetSlot.capabilities?.can_edit;
  const canRespondCancel = !!targetSlot.capabilities?.can_respond_cancelled;

  // Check if user can schedule for others
  const userCanScheduleOthers = canScheduleOthers(authenticatedUser);

  return (
    canEdit &&
    !scheduleInThePast &&
    (schedule.organizer_id === authenticatedUser.user?.id ||
      userCanScheduleOthers ||
      (slotToCheck.resource.type !== 'meeting_room' && canRespondCancel))
  );
}
